import { render, staticRenderFns } from "./SidebarInput.vue?vue&type=template&id=b309e03a&scoped=true&"
import script from "./SidebarInput.vue?vue&type=script&lang=js&"
export * from "./SidebarInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b309e03a",
  null
  
)

export default component.exports